import { FC, useState } from 'react';
import { IClientType, useGetClientTypesQuery } from 'src/redux/services/settings';
import { ClientType } from './ClientType';
import { EditClientType } from './EditClientType';
import styles from './EditClientTypes.module.css';
import { SidePanel } from 'src/components/sidePanel/SidePanel';

type TEditClientTypes = {
  isOpen: boolean;
  onClose: () => void;
};

export const EditClientTypes: FC<TEditClientTypes> = ({ isOpen, onClose }) => {
  const { data: types = [] } = useGetClientTypesQuery();
  const [selectedClientType, setSelectedClientType] = useState<IClientType | undefined>(undefined);
  const [isEditClientTypeOpen, setIsEditClientTypeOpen] = useState(false);

  return (
    <>
      <SidePanel
        onClose={onClose}
        isOpen={isOpen}
        title="Типы приложений"
        description="Настройте типы приложений для различных целей"
        AdditionalAction={() => setIsEditClientTypeOpen(true)}
      >
        <div className={styles.wrapper}>
          {types.map((type) => {
            return (
              <ClientType
                key={type.id}
                type={type}
                onClick={() => {
                  setSelectedClientType(type);
                  setIsEditClientTypeOpen(true);
                }}
              />
            );
          })}
        </div>
      </SidePanel>
      <EditClientType
        isOpen={isEditClientTypeOpen}
        onClose={() => {
          setIsEditClientTypeOpen(false);
          setSelectedClientType(undefined);
        }}
        type={selectedClientType}
      />
    </>
  );
};
